import { customValidators } from "src/app/_helpers/customValidators";
import { Component, OnInit, OnDestroy, ElementRef } from "@angular/core";
import { MenuController } from "@ionic/angular";
import { AuthService } from "../auth.service";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  EmailValidator,
} from "@angular/forms";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { globalHelper } from "src/app/_helpers/global";
import { Utils } from "src/app/_helpers/utils";
import { removeInitScreen } from "src/app/_helpers/appLoading";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.page.html",
  styleUrls: [
    "./forgot-password.page.scss",
    "./../../../_styles/ion-grid-box.scss",
  ],
})
export class ForgotPasswordPage implements OnInit, OnDestroy {
  loading: boolean = false;
  form: FormGroup;
  validationError = false;
  subdomainError = false;
  sended = false;
  subdomain: string;
  isSubdomain: boolean;

  constructor(
    private menu: MenuController,
    private location: Location,
    private router: Router,
    public authService: AuthService,
    private el: ElementRef
  ) {}

  ngOnInit() {
    this.menu.enable(false);

    this.subdomain = Utils.GetSubdomain(window.location.host);
    this.isSubdomain = this.subdomain ? true : false;

    this.form = new FormGroup({
      email: new FormControl(null, {
        updateOn: "blur",
        validators: [
          customValidators.emailPattern,
          Validators.required,
          Validators.maxLength(255),
        ],
      }),
      appName: new FormControl(this.subdomain, {
        updateOn: "blur",
        validators: [
          Validators.required,
          Validators.maxLength(20),
          customValidators.trimValidator(),
        ],
      }),
    });

    removeInitScreen();
  }

  ngOnDestroy() {
    //this.menu.enable(true);
  }

  back() {
    this.location.back();
  }

  save() {
    if (!this.form.valid) {
      this.validationError = true;
      globalHelper.scrollToFirstInvalidControl(this.el);
      return;
    }

    this.authService.emailAddressSended = this.form.controls.email.value;
    if (!this.subdomain) {
      this.subdomain = this.form.controls.appName.value;
    }

    this.authService
      .forgetPassword(this.authService.emailAddressSended, this.subdomain)
      .subscribe(
        (res) => {
          this.sended = true;
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
